import React, { useState, useEffect } from 'react'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'

const COOKIE_KEY = 'cookieConsentAccepted'

const CookieConsentBanner = () => {
  const { t } = useTranslation('home')
  const [ visible, setVisible ] = useState(false)

  useEffect(() => {
    const accepted = localStorage.getItem(COOKIE_KEY)
    if (!accepted) setVisible(true)
  }, [])

  const acceptCookies = () => {
    localStorage.setItem(COOKIE_KEY, 'true')
    setVisible(false)
    // Here you could trigger analytics loading if you block it by default
  }

  if (!visible) return null

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      width: '100%',
      background: 'rgba(3, 12, 19, 0.85)',
      color: '#fff',
      padding: '16px 24px',
      zIndex: 9999,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexWrap: 'wrap',
      fontSize: 16,
    }}>
      <span style={{ marginRight: 16 }}>
        {t('cookieConsent.text')}
        <a href="/privacy-policy/" style={{ color: '#40a9ff', textDecoration: 'underline' }}>{t('cookieConsent.policy')}</a>.
      </span>
      <Button type="primary" size="small" onClick={acceptCookies} style={{ fontWeight: 600 }}>
        {t('cookieConsent.accept')}
      </Button>
    </div>
  )
}

export default CookieConsentBanner
